import AppLoader from '@/app-loader'
import AppRootComponent from '@/App'
import Vue from 'vue'
// import VueCookie from 'vue-cookie'
// Vue.use(VueCookie)
import VueGtag from 'vue-gtag'
import VueMouseflow from 'vue-mouseflow'

Vue.use(VueMouseflow, { tracking_key: '5602cae4-2be6-44f9-a9ab-44796765559a' })
const main = {
  // Store the vue instance singleton
  vueInstance: null
}

let appLoader = new AppLoader()

Vue.use(VueGtag, {
  config: { id: 'G-F3VTP5JBVM', debug: true }
})

appLoader.loadApp(AppRootComponent, '#app', '<App/>').then(vueInstance => {
  main.vueInstance = vueInstance
  main.vueInstance.appHooks.loadRegisteredHooks()
  main.vueInstance.appHooks.run('appLoaded', main.vueInstance)
})


export default main
